import { Input, Switch } from 'antd';

const TeamRegistrationDialog_Specials = ({ registration, setRegistration, seasonSpecialRequests }) => {
  return (
    <>
      <div>
        <h3 className="mt-0">Registration – Special requests (optional)</h3>
        {seasonSpecialRequests?.length == 0
          ?
          <span className='text-sm text-gray-400 mt-4 mb-2'>There are no special options available for this registration. You can complete your request by clicking "Register"</span>
          :
          <>
            {seasonSpecialRequests?.map((specialRequest, idx) => (
              <div key={idx} >
                <div className="flex items-center gap-3 mt-4 mb-2">
                  <Switch
                    checked={registration.SeasonRegistrationSpecials?.find(a => a.name == specialRequest.name)?.enabled}
                    onChange={(checked) => {
                      setRegistration({
                        ...registration,
                        SeasonRegistrationSpecials: (
                          registration.SeasonRegistrationSpecials?.find(a => a.name == specialRequest.name)
                            ? (registration.SeasonRegistrationSpecials ?? [])
                            : [...(registration.SeasonRegistrationSpecials ?? []), { name: specialRequest.name }]
                        ).map(a => a.name != specialRequest.name ? a : { ...a, enabled: checked }),
                      });
                    }}
                  />
                  {specialRequest.label}
                </div>
                <div className={`${registration.SeasonRegistrationSpecials?.find(a => a.name == specialRequest.name)?.enabled ? 'block' : 'hidden'} mt-4`}>
                  {specialRequest.description}
                  <Input.TextArea
                    value={registration.SeasonRegistrationSpecials?.find(a => a.name == specialRequest.name)?.text ?? ''}
                    onChange={(e) => {
                      setRegistration({
                        ...registration,
                        SeasonRegistrationSpecials: registration.SeasonRegistrationSpecials?.map(a => a.name != specialRequest.name ? a : { ...a, text: e.target.value }) ?? [],
                      });
                    }}
                    autoSize={{ minRows: 5, maxRows: 100 }}
                    className="mt-2 mb-2 w-full"
                    placeholder={specialRequest.placeholder}
                  />
                </div>
              </div>
            ))}
          </>
        }
      </div>
    </>
  );
}

export default TeamRegistrationDialog_Specials
